import store from '../../store/index.js'

export function clearLoginState () {
  window.sessionStorage.removeItem('headmenu')
  window.sessionStorage.removeItem('type')
  window.localStorage.removeItem('username')
  // vuex-persistedstate 整包缓存，必须移除否则刷新后 token 会恢复
  window.sessionStorage.removeItem('vuex')
  store.commit('setToken', '')
  store.commit('LOGOOUT')
}



// WEBPACK FOOTER //
// ./src/assets/js/auth.js